<template>
  <div class="mb-6">

    <div class="columns is-multiline">
      <div class="column is-12-mobile is-2-tablet">
        <div class="field">
          <label class="label">Intervallo date</label>
          <InputDate v-model="filters.range" @update="onFilterInput" placeholder="Intervallo date" :range="true" :showIcon="true" />
        </div>
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputSelect
          name="Utente"
          v-model="filters.user"
          :options="$store.getters.users"
          id="_id"
          track-by="_id"
          :custom-label="$fullname"
          @select="filterOperators"
          @remove="filterOperators(false)"
        />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Fornitore" v-model="filters.supplier" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Prodotto" v-model="filters.product" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Note" v-model="filters.notes" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputSelect
          name="Archiviato"
          v-model="filters.archived"
          @select="onFilterInput"
          :options="[{'label': 'Sì', value: true}, {'label': 'No', value: false}]"
          id="value"
          track-by="value"
          label="label"
          :allowEmpty="false"
        />
      </div>
      <div class="column is-12-mobile is-4-tablet">
        <label class="label">&nbsp;</label>
        <div class="buttons is-flex">
          <button class="button" @click="resetFilters()"><font-awesome-icon icon="filter-circle-xmark" />Reset</button>
          <router-link to="/ordini/new" class="button is-primary is-hidden-touch" @click="resetFilters()"><font-awesome-icon icon="plus" />Aggiungi</router-link>
        </div>
      </div>
    </div>

    <div class="b-table has-pagination" :class="{'is-loading': loading}">
      <div class="table-wrapper has-mobile-cards">
        <table class="table is-fullwidth is-striped is-hoverable">
          <thead>
          <tr>
            <th>Data</th>
            <th>Utente</th>
            <th>Fornitore</th>
            <th>Ordinato</th>
            <th>Prodotti</th>
            <th>Destinazioni</th>
            <th>Totale</th>
            <th>Totale scontato</th>
            <th>Ricevuti</th>
            <th>Bolle</th>
            <th>Note</th>
            <th style="min-width: 100px;"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(order, index) in orders" :key="index">
            <td data-label="Data">
              <div v-if="order.date">{{new Date(order.date).toDisplay()}}</div>
            </td>
            <td data-label="Utente">
              {{$fullname(order.user)}}
            </td>
            <td data-label="Fornitore">
              {{order.supplier}}
            </td>
            <td data-label="Ordinato">
              <div v-if="order.isRequested" class="has-text-success has-text-centered">
                <font-awesome-icon icon="fa-regular fa-circle-check" />
              </div>
              <div v-else class="has-text-danger has-text-centered">
                <font-awesome-icon icon="fa-regular fa-circle-xmark" />
              </div>
            </td>
            <td data-label="Prodotti">
              <div v-for="(product, index) in order.products" :key="index">
                {{ product.quantity }}x {{ product.brand }} {{ product.code }} {{ product.name }}
              </div>
            </td>
            <td data-label="Destinazioni">
              <div v-if="calcTotalOperations(order.products)?.operation" style="white-space: nowrap;">Appuntamenti: {{ calcTotalOperations(order.products).operation }}</div>
              <div v-if="calcTotalOperations(order.products)?.direct" style="white-space: nowrap;">Dirette: {{ calcTotalOperations(order.products).direct }}</div>
            </td>
            <td data-label="Totale">
              <div style="white-space: nowrap;">{{calcTotalPrice(order)}}</div>
            </td>
            <td data-label="Totale scontato">
              <div style="white-space: nowrap;">{{calcTotalPriceDiscounted(order)}}</div>
            </td>
            <td data-label="Ricevuti">
              {{ calcReceived(order) }}/{{ order.products?.length }}
            </td>
            <td data-label="Bolle">
              <div v-for="(shippingNote, index) in order.shippingNotes" :key="index">
                <a :href="baseUrl + '/uploads/' + shippingNote.attachment" target="_blank">{{shippingNote.attachment}}</a>
              </div>
            </td>
            <td data-label="Note">
              {{order.notes}}
            </td>
            <td class="is-actions-cell is-justify-content-flex-end">
              <div class="buttons is-right">
                <button v-if="!order.archived" class="button is-secondary" @click="archive(order, true)" title="Concludi" :class="[{'is-loading': order.waitArchive}]" :disabled="order.waitArchive">
                  <span class="icon"><font-awesome-icon icon="lock" /></span>
                </button>
                <button v-if="order.archived" class="button is-secondary" @click="archive(order, false)" title="Ripristina" :class="[{'is-loading': order.waitArchive}]" :disabled="order.waitArchive">
                  <span class="icon"><font-awesome-icon icon="lock-open" /></span>
                </button>
                <router-link :to="'/ordini/' + order._id" class="button is-warning" type="button" title="Modifica" :disabled="order.waitDelete">
                  <span class="icon"><font-awesome-icon icon="pen" /></span>
                </router-link>
                <button class="button is-danger" type="button" @click="deleteOrder(order)" title="Elimina" :class="[{'is-loading': order.waitDelete}]" :disabled="order.waitDelete">
                  <span class="icon"><font-awesome-icon icon="trash-can" /></span>
                </button>
              </div>
            </td>
          </tr>
          <tr v-if="orders.length === 0">
            <td colspan="100" class="has-text-centered has-text-grey">
              <i>Nessun risultato</i>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <Pagination :pagination="pagination" @change="getOrders($event)" />
    </div>

    <router-link to="/ordini/new" class="button is-floating is-primary is-hidden-desktop" title="Nuovo">
      <span class="icon">
        <font-awesome-icon icon="plus" />
      </span>
    </router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {
      baseUrl: import.meta.env.VITE_SERVER,
      
      filters: this.$store.state.filters.order,

      orders: [],

      pagination:{
        total: false,
        selected: false
      },

      loading: true
    }
  },

  methods: {
    resetFilters() {
      this.filters = {
        range: null,
        archived: {'label': 'No', value: false}
      }

      this.getOrders()
    },

    filterOperators(selected) {
      this.filters.operator = selected
      this.getOrders()
    },

    getOrders(args = {page: 1, size: 30, scroll: 0}) {
      const self = this
      
      this.loading = true

      this.$store.commit('setFilter', {name: 'order', value: this.filters})
      this.$store.commit('setPage', {name: 'order', value: {number: args.page, size: args.size}})

      const startDate = this.filters.range ? this.filters.range.start.toDateInputValue() : null
      const endDate = this.filters.range ? this.filters.range.end.toDateInputValue() : null
      const userId = this.filters.user ? this.filters.user._id : null
      const supplier = this.filters.supplier
      const productText = this.filters.product
      const notes = this.filters.notes
      const archived = this.filters.archived ? this.filters.archived.value : null

      this.$http.get('/order', { params: {
        page: args.page,
        size: args.size,
        user: userId,
        startDate,
        endDate,
        supplier,
        productText,
        notes,
        archived
      } }).then(response => {
        if (response && response.data) {
          this.orders = response.data.records
          this.pagination = {
            total: response.data.totalRecords,
            pages: response.data.totalPages,
            selected: response.data.currentPage
          }

          if (args.scroll) {
            self.$nextTick(() => {
              window.scroll(0, args.scroll)
            })
          }
        }

        this.loading = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.loading = false
      })
    },

    deleteOrder(order) {
      if (confirm('Eliminare?')) {
        const self = this
        order.waitDelete = true

        this.$http.delete('/order/' + order._id)
        .then(function (response) {
          self.getOrders({page: self.$store.state.pages.order.number, size: self.$store.state.pages.order.size})
        })
        .catch(function (error) {
          console.log(error)
          alert('Errore')
          order.waitDelete = false
        })
      }
    },

    archive(order, value) {
      const self = this
      order.waitArchive = true

      this.$http.put('/order/' + order._id, {archived: value})
      .then(function (response) {
        self.getOrders()
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        order.waitArchive = false
      })
    },

    calcReceived(order) {
      let received = 0
      order.products.forEach(product => {
        if (product.isReceived) {
          received++
        }
      })

      return received
    },

    calcTotalPrice(order) {
      let totalPrice = 0
      order.products.forEach(product => {
        const price = product.price ? product.price?.replace('€', '')?.trim().replace(',', '.') : 0
        const quantity = product.quantity ? product.quantity : 1
        totalPrice += price * quantity
      })

      if (isNaN(totalPrice)) {
        return 'Errore'
      } else {
        return '€ ' + totalPrice.toFixed(2)
      }
    },

    calcTotalPriceDiscounted(order) {
      let totalPrice = 0
      order.products.forEach(product => {
        const price = product.price ? product.price?.replace('€', '')?.trim().replace(',', '.') : 0
        const discount = product.discount ? product.discount : 0
        const quantity = product.quantity ? product.quantity : 1
        totalPrice += (price - (price * discount / 100)) * quantity
      })

      if (isNaN(totalPrice)) {
        return 'Errore'
      } else {
        return '€ ' + totalPrice.toFixed(2)
      }
    },

    calcTotalOperations(order) {
      let totalOperation = 0
      let totalDirect = 0

      order.forEach(product => {
        if (product.linked?.length) {
          product.linked.forEach(linked => {
            if (linked.direct) {
              totalDirect++
            } else if (linked.operation) {
              totalOperation++
            }
          })
        }
      })

      return {
        operation: totalOperation,
        direct: totalDirect
      }
    }
  },

  mounted() {
    this.getOrders({page: this.$store.state.pages.order.number, size: this.$store.state.pages.order.size, scroll: this.$store.state.pages.order.scroll})
  },

  created() {
    this.onFilterInput = this.$debounce(() => this.getOrders(), 500)
  },

  beforeUnmount() {
    const scroll = window.top.scrollY
    let page = Object.assign({}, this.$store.state.pages.order)
    page.scroll = scroll
    this.$store.commit('setPage', {name: 'order', value: page})
  }
}
</script>